import { View } from "../view";

export enum ModalResultType
{
    OK = 'ok',
    YES = 'yes',
    NO = 'no',
    CANCEL = 'cancel',
    SAVE = 'save'
}

export interface ModalResult<T extends Object>
{
    type: ModalResultType;
    data: T;
}

export abstract class BaseModal extends View
{
    public title = '';
    public message = '';

    public result: ModalResult<Object>;

    constructor(title = '', message = '', data?)
    {
        super(data);
        this.title = title;
        this.message = message;
        this.data.title = title;
        this.data.message = message;
    }

    public close(resultType = ModalResultType.OK, data = undefined): PromiseLike<void>
    {
        this.result = {
            type: resultType,
            data: data
        }

        return new Promise((resolve, reject) =>
        {
            this.element.addEventListener('transitionend', () =>
            {
                super.close().then(resolve);
            });
            this.element.classList.remove('visible');
        });
    }

    public afterRender(): PromiseLike<void>
    {
        setTimeout(() => {
            this.element.classList.add('visible');
        }, 50);

        return super.afterRender();
    }
}

export interface ModalConstructor
{
    new (): BaseModal;
}